/**
 * Region list + marketplace chip rules for the Connect Amazon step (/connect and the teammate
 * invite page). Marketplace lists are the same ones AmazonRegionConnect uses.
 */
import {
  AMAZON_CONNECT_MARKETPLACES_BY_REGION,
  amazonAuthorizationQueryMarketplace
} from './amazonSellingPartnerOAuth'

/** Display order. Names are Amazon's own ("North America", not "Americas"). */
export var CONNECT_REGIONS = [
  { key: 'NA', name: 'North America' },
  { key: 'EU', name: 'Europe' },
  { key: 'ME', name: 'Middle East' },
  { key: 'IN', name: 'India' },
  { key: 'FE', name: 'Asia Pacific' }
].map(function (r) {
  var marketplaces = AMAZON_CONNECT_MARKETPLACES_BY_REGION[r.key]
  return {
    key: r.key,
    name: r.name,
    codes: marketplaces.map(function (o) { return o.code }),
    marketplaces: marketplaces
  }
})

export function connectRegion (key) {
  var k = String(key || '').toUpperCase()
  for (var i = 0; i < CONNECT_REGIONS.length; i++) {
    if (CONNECT_REGIONS[i].key === k) return CONNECT_REGIONS[i]
  }
  return null
}

export function connectRegionName (key) {
  var r = connectRegion(key)
  return r ? r.name : ''
}

/**
 * Default region from the browser's UTC offset in hours (east of UTC is positive):
 * ≤ −2 North America, < +3 Europe, < +5 Middle East, < +6.5 India, otherwise Asia Pacific.
 */
export function guessRegionFromUtcOffset (offsetHours) {
  var o = Number(offsetHours)
  if (isNaN(o) || o <= -2) return 'NA'
  if (o < 3) return 'EU'
  if (o < 5) return 'ME'
  if (o < 6.5) return 'IN'
  return 'FE'
}

/** getTimezoneOffset() is minutes *behind* UTC (New York = 240), hence the sign flip. */
export function guessRegionFromBrowser (date) {
  var d = date || new Date()
  return guessRegionFromUtcOffset(-d.getTimezoneOffset() / 60)
}

/** Keeps only the region's codes, in the region's display order. */
function inRegionOrder (region, codes) {
  var list = Array.isArray(codes) ? codes : []
  return region.codes.filter(function (c) { return list.indexOf(c) !== -1 })
}

export function selectedCodes (key, selected) {
  var r = connectRegion(key)
  return r ? inRegionOrder(r, selected) : []
}

export function allCodesSelected (key, selected) {
  var r = connectRegion(key)
  return !!r && inRegionOrder(r, selected).length === r.codes.length
}

/** "All": selects every marketplace, or clears them when every one is already on. */
export function toggleAllCodes (key, selected) {
  var r = connectRegion(key)
  if (!r) return []
  if (r.codes.length === 1) return r.codes.slice()
  return allCodesSelected(key, selected) ? [] : r.codes.slice()
}

/** One chip on/off. A one-marketplace region (India) always stays on. */
export function toggleCode (key, selected, code) {
  var r = connectRegion(key)
  if (!r) return []
  if (r.codes.length === 1) return r.codes.slice()
  var current = inRegionOrder(r, selected)
  if (r.codes.indexOf(code) === -1) return current
  var next = current.indexOf(code) === -1
    ? current.concat([code])
    : current.filter(function (c) { return c !== code })
  return inRegionOrder(r, next)
}

/** Button copy follows the selection: whole region, some marketplaces, or none (disabled). */
export function connectButtonLabel (key, selected) {
  var r = connectRegion(key)
  var codes = r ? inRegionOrder(r, selected) : []
  if (!codes.length) return 'Pick at least one marketplace'
  if (codes.length === r.codes.length) return 'Connect Amazon ' + r.name + ' →'
  return 'Connect Amazon ' + codes.join(', ') + ' →'
}

/**
 * Query params for GET /api/identity/amazon/authorization/redirect (and the invite redirect).
 * Every marketplace: allMarketplaces=true, as AmazonRegionConnect sends it.
 * A subset: allMarketplaces=false&marketplaceCodes=US,CA (the first code picks the Seller Central host).
 * Returns null when nothing is selected.
 */
export function connectAuthorizationParams (key, selected) {
  var r = connectRegion(key)
  var codes = r ? inRegionOrder(r, selected) : []
  if (!codes.length) return null
  var all = codes.length === r.codes.length
  var first = r.marketplaces[r.codes.indexOf(codes[0])]
  return {
    region: r.key,
    allMarketplaces: all,
    marketplaceCodes: codes.join(','),
    marketplaceCode: codes.join(','),
    marketplace: all ? amazonAuthorizationQueryMarketplace(r.key) : first.marketplaceId
  }
}



// WEBPACK FOOTER //
// ./src/utils/connectRegions.js